// eslint-disable-next-line no-shadow
export var RecaptchaAction;
(function (RecaptchaAction) {
    RecaptchaAction["ADD_GIFT_CARD"] = "Add_Gift_Card";
    RecaptchaAction["B2C_UPDATE_PERSONAL_DETAILS"] = "B2C_Update_Personal_Details";
    RecaptchaAction["DEFAULT"] = "Default";
})(RecaptchaAction || (RecaptchaAction = {}));
